<template>
    <TransitionRoot appear :show="isOpen" as="template" @after-leave="restoreModalFocus">
        <Dialog as="div" @close="$emit('close')" class="relative z-50">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                        <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white px-5 py-5 z-70 text-left align-middle shadow-xl transition-all flex flex-col justify-center items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ef4444" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                            </svg>

                            <DialogTitle>
                                <h2 class="text-base font-semibold text-center mb-2 mt-2">{{ title }}</h2>
                            </DialogTitle>
                            <p class="text-xs font-kiralabunuthin ts:text-sm text-center">{{ message }}</p>

                            <!-- Metin içeren modallarda da odaklanabilir bir kapatma öğesi sağlar. -->
                            <button type="button" aria-label="Kapat" class="absolute top-2 right-5 cursor-pointer p-2 focus-visible:ring-2 focus-visible:ring-kbgreen" @click="$emit('close')">x</button>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
    import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

    import { useModalFocus } from "@/Composables/useModalFocus";

    export default {
        name: "ErrorModal",
        components: {
            TransitionRoot,
            TransitionChild,
            Dialog,
            DialogPanel,
            DialogTitle,
        },
        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
            title: {
                type: String,
                default: "Hata",
            },
            message: {
                type: String,
                required: true,
            },
        },
        emits: ["close"],
        setup(props) {
            return useModalFocus(() => props.isOpen);
        },
    };
</script>
